// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "transfer-2PmEV";
var _3 = "transfer__layover-rrTAu";
var _4 = "warning-3Shlh";
var _5 = "warning__icon-3Ig1A";
var _6 = "warning_red-3-EVN";
var _7 = "technicalLandingIn-1G2DC";
export { _1 as "__esModule", _2 as "transfer", _3 as "transfer__layover", _4 as "warning", _5 as "warning__icon", _6 as "warning_red", _7 as "technicalLandingIn" }
export default { "__esModule": _1, "transfer": _2, "transfer__layover": _3, "warning": _4, "warning__icon": _5, "warning_red": _6, "technicalLandingIn": _7 }
